import { z } from "zod";

/**
 * ReportFolhaPagamentoColunasSchema
 */

export const ReportFolhaPagamentoColunasSchema = z.object({
  nro: z.boolean(),
  centroCusto: z.boolean(),
  folhaPagamento: z.boolean(),
  funcionarioFolha: z.boolean(),
  bancoPagamento: z.boolean(),
  notaFiscal: z.boolean(),
  nroDoc: z.boolean(),
  responsavel: z.boolean(),
  status: z.boolean(),
  titulo: z.boolean(),
  subConta: z.boolean(),
  dataPagar: z.boolean(),
  dataPago: z.boolean(),
  valorPagar: z.boolean(),
  valorPago: z.boolean(),
  observacoes: z.boolean(),
});

/**
 * ReportFolhaPagamentoColunas
 */

export type ReportFolhaPagamentoColunas = z.infer<typeof ReportFolhaPagamentoColunasSchema>;

/**
 * ReportFolhaPagamentoSchema
 */

export const ReportFolhaPagamentoSchema = z.object({
  titulo: z.string().nullable().default(null),
  subcontas: z.array(z.number()).nullable().default(null),
  folhaPagamentos: z.array(z.number()).nullable().default(null),
  centroCustos: z.array(z.number()).nullable().default(null),
  funcionarios: z.array(z.number()).nullable().default(null),
  bancoPagamentos: z.array(z.number()).nullable().default(null),
  status: z.array(z.number()).nullable().default(null),
  dataPagarDe: z.date().nullable().default(null),
  dataPagarAte: z.date().nullable().default(null),
  dataPagoDe: z.date().nullable().default(null),
  dataPagoAte: z.date().nullable().default(null),
  colunas: ReportFolhaPagamentoColunasSchema.default({
    nro: false,
    centroCusto: false,
    folhaPagamento: false,
    funcionarioFolha: false,
    bancoPagamento: false,
    notaFiscal: false,
    nroDoc: false,
    responsavel: false,
    status: false,
    titulo: false,
    subConta: false,
    dataPagar: false,
    dataPago: false,
    valorPagar: false,
    valorPago: false,
    observacoes: false,
  }),
});

/**
 * ReportFolhaPagamentoForm
 */

export type ReportFolhaPagamentoForm = z.infer<typeof ReportFolhaPagamentoSchema>;

/**
 * initialFolhaPagamentoFormValues
 */

export const initialFolhaPagamentoFormValues: ReportFolhaPagamentoForm = {
  titulo: null,
  subcontas: null,
  folhaPagamentos: null,
  centroCustos: null,
  funcionarios: null,
  bancoPagamentos: null,
  status: null,
  dataPagarDe: null,
  dataPagarAte: null,
  dataPagoDe: null,
  dataPagoAte: null,
  colunas: {
    nro: false,
    centroCusto: false,
    folhaPagamento: false,
    funcionarioFolha: false,
    bancoPagamento: false,
    notaFiscal: false,
    nroDoc: false,
    responsavel: false,
    status: false,
    titulo: false,
    subConta: false,
    dataPagar: false,
    dataPago: false,
    valorPagar: false,
    valorPago: false,
    observacoes: false,
  },
};